export default "__VITE_ASSET__CHiJKWwp__"